export const ROOT_NODE_ID = 'rootNode'
export const ROOT_NODE_INDENTATION = -1

export function indentedListToTree(elements) {
    const ancestorIdStack = [ROOT_NODE_ID]
    const nodes = { rootNode: { id: ROOT_NODE_ID, childrenIds: [] } }
    let previousIndentation = ROOT_NODE_INDENTATION
    elements.forEach((element) => {
        const { indentation, id } = element

        const popN = previousIndentation - indentation + 1
        ancestorIdStack.splice(ancestorIdStack.length - popN)

        const parentId = ancestorIdStack[ancestorIdStack.length - 1]
        ancestorIdStack.push(id)

        previousIndentation = indentation

        nodes[parentId].childrenIds.push(id)
        nodes[id] = {
            id,
            parentId,
            text: element.text,
            type: element.type,
            deadline: element.deadline,
            childrenIds: []
        }
    })
    return nodes
}

export function treeToIndentedList(tree) {
    return nodeToIndentedList(tree, ROOT_NODE_ID)
}

function nodeToIndentedList(tree, id) {
    const node = tree[id]
    const childrenIds = node.childrenIds
    const data = []
    if (id !== ROOT_NODE_ID) {
        const item = {
            id: node.id,
            type: node.type,
            text: node.text,
            indentation: ROOT_NODE_INDENTATION
        }
        if (node.deadline) item.deadline = node.deadline
        data.push(item)
    }
    childrenIds.forEach((childId) => {
        let childrenData = nodeToIndentedList(tree, childId)
        childrenData = childrenData.map((child) => {
            child.indentation += 1
            return child
        })

        data.push(...childrenData)
    })
    return data
}
